import { useMutation } from '@tanstack/react-query';
import {
  createInternalTransfer,
  type InternalTransferRequestParams,
  type InternalTransferResponse,
} from '../requests';

interface UseInternalTransferOptions {
  onSuccess?: (data: InternalTransferResponse) => void;
  onError?: (error: Error) => void;
}

export function useInternalTransfer({
  onSuccess,
  onError,
}: UseInternalTransferOptions) {
  const mutation = useMutation<
    InternalTransferResponse,
    Error,
    InternalTransferRequestParams
  >({
    mutationFn: createInternalTransfer,
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isTransferring: mutation.isPending,
    isError: mutation.isError,
    transferError: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
